
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404VBDnzLiQQZgE_45DitlPqalyxJsmo2G3y_rOmhOpqkQq0Meta } from "/var/www/nuxt/pages/404.vue?macro=true";
import { default as indexU1_45_IvHqDeHPguG_45X_tKFeG0G0YkqPlBtj75omUZSmAMeta } from "/var/www/nuxt/pages/index.vue?macro=true";
import { default as _91slug_93QBWFcqfRCLCGHh63XWOe7uutJQo4nWpXcBcmKbtkMIQMeta } from "/var/www/nuxt/pages/[slug].vue?macro=true";
import { default as sitemapAvKbbRyNHIOZaUflAAYrAVRpITNpUYWXJ8953HifUGsMeta } from "/var/www/nuxt/pages/sitemap.vue?macro=true";
import { default as impressumsW9e3ddF9LpNw4AukxvGwNK0NSuDNpeVlXP7eTllJJMMeta } from "/var/www/nuxt/pages/impressum.vue?macro=true";
import { default as datenschutzwNyyOQq6epqmkW2ihGrT2C_L5AArgs_45qp71FpnnEtgEMeta } from "/var/www/nuxt/pages/datenschutz.vue?macro=true";
import { default as _91slug_93qqQqJ4Ef2LA9ViHUL_458bbMdg9eevMzy5WACVIt5pI2gMeta } from "/var/www/nuxt/pages/[topics]/[slug].vue?macro=true";
import { default as barrierefreiheitis1pW3RIaLzeqoKwnK1vrFwTwBtQZHqYK_45NYVkBRPBEMeta } from "/var/www/nuxt/pages/barrierefreiheit.vue?macro=true";
import { default as _91slug_93oImgoktI_45_txRyWCnPg3qsJZVR5MPouvHV7vhollTucMeta } from "/var/www/nuxt/pages/[topics]/[children]/[slug].vue?macro=true";
import { default as _91slug_93HTt6U52MINKAq2cs_458KWJLeDn87pApXe8ZpY1hWT9bYMeta } from "/var/www/nuxt/pages/[topics]/[children]/[grandchildren]/[slug].vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    component: () => import("/var/www/nuxt/pages/404.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/nuxt/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/var/www/nuxt/pages/[slug].vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/var/www/nuxt/pages/sitemap.vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/var/www/nuxt/pages/impressum.vue")
  },
  {
    name: "datenschutz",
    path: "/datenschutz",
    component: () => import("/var/www/nuxt/pages/datenschutz.vue")
  },
  {
    name: "topics-slug",
    path: "/:topics()/:slug()",
    component: () => import("/var/www/nuxt/pages/[topics]/[slug].vue")
  },
  {
    name: "barrierefreiheit",
    path: "/barrierefreiheit",
    component: () => import("/var/www/nuxt/pages/barrierefreiheit.vue")
  },
  {
    name: "topics-children-slug",
    path: "/:topics()/:children()/:slug()",
    component: () => import("/var/www/nuxt/pages/[topics]/[children]/[slug].vue")
  },
  {
    name: "topics-children-grandchildren-slug",
    path: "/:topics()/:children()/:grandchildren()/:slug()",
    component: () => import("/var/www/nuxt/pages/[topics]/[children]/[grandchildren]/[slug].vue")
  }
]